// import foo from './foo';
import widgetData from './subaru-service';
import accountData from './account-data';

const root = {
	widgetData,
	accountData
};

export default root;
